import { createFileRoute } from '@tanstack/react-router';

import { ProjectOverviewPage } from '../../features/manager-project-overview/components/ProjectOverviewPage';

export const Route = createFileRoute('/_onboarding/project')({
  component: ProjectRoute,
});

function ProjectRoute() {
  return <ProjectOverviewPage />;
}
